export default {
  loading: {
    id: 'spinner',
    defaultMessage: 'Loading',
  },
  title: {
    id: 'dashboard_menu_orders',
    defaultMessage: 'My orders',
  },
  subtitle: {
    id: 'dashboard_menu_orders_subtitle',
    defaultMessage: 'Delivery tracking, customer service, etc.',
  },
  guestUpgradeSuccessTitle: {
    id: 'dashboard_orders_guest_upgrade_toast_success_title',
    defaultMessage: 'Your account is ready',
  },
  guestUpgradeSuccessContent: {
    id: 'dashboard_orders_guest_upgrade_toast_success_content',
    defaultMessage: 'Track orders or ask for help.',
  },
}
